import { message } from "antd";
import Router from "../..";
import { handleApiError } from "./indexApi";

const BASE_URL = process.env.REACT_APP_API_URL_PRO;

export const noticeApi = {
  // 알람 목록 조회
  getAlarmList: async ({ page = 1 } = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/notice/get/alarm`,
        {
          params: { page },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "알람 목록 조회에 실패했습니다.");
      return null;
    }
  },

  readAlarm: async (id) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/notice/read/alarm`,
        { id },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data?.result) return true;
      return false;
    } catch (err) {
      handleApiError(err, "알람 읽음 처리에 실패했습니다.");
      return false;
    }
  },

  readAllAlarm: async () => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/notice/readall/alarm`,
        {},
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data?.result) return true;
      return false;
    } catch (err) {
      handleApiError(err, "모든 알람 읽음 처리에 실패했습니다.");
      return false;
    }
  },

  getNoticeList: async ({ type, page = 1 } = {}) => {
    try {
      const res = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/admin/get/notice`,
        {
          params: { type, page },
          headers: { authorization: localStorage.getItem("authorization") },
        }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return null;
      }
      return res.data;
    } catch (err) {
      handleApiError(err, "공지사항 목록 조회에 실패했습니다.");
      return null;
    }
  },

  // 관리자에게 채팅 알림 보내기
  sendChatAlarm: async ({ user_id, username }) => {
    try {
      const res = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/admin/create/channeltalk/alarm`,
        { user_id, username },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (res.data?.error?.text) {
        message.error(res.data.error.text);
        return false;
      }
      return !!res.data?.result;
    } catch (err) {
      handleApiError(err, "채팅 알림 보내기에 실패했습니다.");
      return false;
    }
  },
};
